module.exports = __webpack_public_path__ + "/a4b84bc3a5a6ff494b750685992ecffb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/feature_icons/support_icon_@2x.svg
 ** module id = 1538
 ** module chunks = 0
 **/